import { getEnv } from "../../config/getEnv";

const BE_URL = getEnv("REACT_APP_BE_URL") || "http://localhost:8080";

function getAuthBaseUrl() {
  return BE_URL.replace(/\/$/, "");
}

export async function syncAzureTokenCookies({
  access_token,
  id_token,
  expires_in,
}) {
  if (!access_token) return;
  const url = `${getAuthBaseUrl()}/api/auth/azure/token`;
  const headers = { "Content-Type": "application/json" };
  if (typeof window !== "undefined" && window.location?.origin) {
    headers["X-App-Origin"] = window.location.origin;
  }
  await fetch(url, {
    method: "POST",
    credentials: "include",
    mode: "cors",
    headers,
    body: JSON.stringify({ access_token, id_token, expires_in }),
  });
}

export async function clearAzureCookiesViaBackend() {
  const url = `${getAuthBaseUrl()}/api/auth/azure/logout`;
  const headers = {};
  if (typeof window !== "undefined" && window.location?.origin) {
    headers["X-App-Origin"] = window.location.origin;
  }
  await fetch(url, {
    method: "POST",
    credentials: "include",
    mode: "cors",
    headers,
  });
}
